import { render, staticRenderFns } from "./addContestAdmin.vue?vue&type=template&id=1fb0f04d&scoped=true"
import script from "./addContestAdmin.vue?vue&type=script&lang=js"
export * from "./addContestAdmin.vue?vue&type=script&lang=js"
import style0 from "./addContestAdmin.vue?vue&type=style&index=0&id=1fb0f04d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb0f04d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb0f04d')) {
      api.createRecord('1fb0f04d', component.options)
    } else {
      api.reload('1fb0f04d', component.options)
    }
    module.hot.accept("./addContestAdmin.vue?vue&type=template&id=1fb0f04d&scoped=true", function () {
      api.rerender('1fb0f04d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/addContestAdmin.vue"
export default component.exports